import { configuration, cfRtdConfiguration, c2bVasRtdConfiguration, b2cRecommendationConfiguration} from "../../constants/firebase-constants";

export const FIREBASE_CONFIG_TYPE = {
    "DEFAULT": configuration,
    "CF_RTD": cfRtdConfiguration,
    "C2B_VAS_RTD": c2bVasRtdConfiguration,
    "B2C_RECOMMENDATION": b2cRecommendationConfiguration
};

export const RTD_AUTH_TOKEN = {
    QA: "customerAppUserStage",
    STAGING: "customerAppUserStage",
    PRODUCTION: "customerAppUser"
};

export const RTD_DB_REF = "preApprovedOffer";

export const CF_RTD = "CF_RTD";

export const OKYC_DB_REF = "okyc";

export const B2C_RECOMMENDATION = "B2C_RECOMMENDATION";

